import React from 'react'
import { useSelector } from 'react-redux'
import SVGIcon from '../svg/SVGIcon'
import leaf from './leaf.svg'
import { withFrenchSite } from '../i18n/i18nSite'
import { MULTIPATH_MODE_CAR, MULTIPATH_MODE_MOTORBIKE } from '../../store/itinerary/itinerary.constants'
import { getRouteLengthValue, selectCurrentRoute } from '../../store/itinerary/routes.selectors'
import s from './ItineraryAwarenessMessage.less'
import { selectCurrentMode } from '../../store/itinerary/itinerary.selectors'

const AWARENESS_MESSAGE_SHORT_DISTANCE = 10_000
const AWARENESS_MESSAGE_MEDIUM_DISTANCE = 50_000
const AWARENESS_MESSAGE_LONG_DISTANCE = 200_000

const getMessageFromDistance = distance => {
  if (distance < AWARENESS_MESSAGE_SHORT_DISTANCE) return 'Pour les trajets courts, privilégiez la marche ou le vélo'
  if (distance < AWARENESS_MESSAGE_MEDIUM_DISTANCE) return 'Au quotidien, prenez les transports en commun'
  if (distance < AWARENESS_MESSAGE_LONG_DISTANCE) return 'Pensez à covoiturer'
  return 'Passer de 130 à 110km/h sur autoroute réduit votre consommation de 20%'
}

const ItineraryAwarenessMessage = () => {
  const mode = useSelector(selectCurrentMode)
  const route = useSelector(selectCurrentRoute)
  const distanceInMeter = getRouteLengthValue(route)

  if (mode !== MULTIPATH_MODE_CAR && mode !== MULTIPATH_MODE_MOTORBIKE) return <></>

  const catchphrase = '#SeDéplacerMoinsPolluer'

  return (
    <div className={s.AwarenessContainer}>
      <div className={s.leafIconContainer}>
        <SVGIcon url={leaf} className={s.leafIcon} />
      </div>
      <div className={s.textContainer}>
        <span className={s.message}>{getMessageFromDistance(distanceInMeter)}</span>
        <span className={s.catchphrase}>{catchphrase}</span>
      </div>
    </div>
  )
}

export default withFrenchSite(ItineraryAwarenessMessage)
